import { useStore } from '@/containers'

export interface PreOrderCardProps {
  price: number
  type: string
}

const PreOrderCard = ({ price, type }: PreOrderCardProps) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }
  return (
    <div
      className={`${
        type == 'product-detail' ? ' mt-2' : ''
      } bg-preOrder text-center rounded-full flex items-center justify-center h-full w-full`}
    >
      <span className='text-white sm:text-[10px] md:text-[11px] font-bold mr-1'>
        Đặt trước:
      </span>
      <span className='text-white text-[12px] font-extrabold'>
        {price
          ?.toLocaleString(selectedLang as string, {
            style: 'currency',
            currency: currency(selectedLang as string),
          })
          .replace(/\s₫/g, 'đ')}
      </span>
    </div>
  )
}

export default PreOrderCard
